module.exports = __webpack_public_path__ + "1afe49b4fa24ce99513b2ca93e9286b4.svg";